import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon7 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";
import Icon5 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon6 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import TestimonialImage from "../../../../../assets/images/png/courses/testimonies/Mayowa Adeojo.jpeg";

import Instructor3 from "../../../../../assets/images/png/courses/instructors/chisom.webp";
import Instructor2 from "../../../../../assets/images/png/courses/instructors/damilare.jpg";
import Instructor4 from "../../../../../assets/images/png/courses/instructors/monday.jpg";
import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";

import Testimony1 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/adeojo.webp";
import Testimony3 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/ayodeji.webp";
import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/jude.webp";

import PortfolioImage from "../../../../../assets/images/png/courses/portfolio/data.webp";
import PortfolioUserAvatar from "../../../../../assets/images/png/courses/portfolio/samuel.jpeg";

import BusinessImage from "../../../../../assets/images/svg/business.svg";
import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import DataSciencePreview from "../../../../../assets/images/jpeg/dataSciencePreview.jpg";

export const dataScienceFellowshipEurope = {
  id: 1,
  tag: "FOR DATA ENTHUSIASTS",
  title: "Data Science Bootcamp",
  description: `
  At Utiva, you can earn an accredited Data Science certificate that will position 
  you as the next Data Scientist for the fast-growing tech industry. Learn the 
  foundations of Data Science, Python, data visualisations, modelling, machine learning, and more.
    `,
  duration: "6 Months",

  downloadBrochureUrl:
    "https://drive.google.com/file/d/1zo0mYr0l0MU5NaxfvLLwXtdC7o6HrT6Z/view?usp=sharing",

  bookCallUrl:
    "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1PA4tqYlKUaUAr3aLVwwLAHZsmUOixiPZvAEfvCvOvOD3TnyicP2mHeo8HGW9tSrmaHbyso32h",
  chatWithUsUrl: "https://wa.me/12028217864",

  courseFormUrl: "courses/data-science-bootcamp/fill-form",

  jobTitle: "Data Scientist",

  kickoffDate: "December 2",
  kickoffTime: "5:00 PM - 8:00 PM EDT",

  testimonial: {
    image: TestimonialImage,
    name: "Mayowa Adeojo",
    role: "Business and Data Analyst, Union Bank",
    testimony: `
    Utiva has impacted my career progression in a positive way 
    as the changes in the last couple of months have been rapid. 
    I've had to change roles to a business-oriented role. I've 
    had opportunities to implement my learnings in real-life 
    scenarios, had a role change to a Data Science role, at 
    one of the top financial Institutions in Nigeria.
`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `The Utiva Data Bootcamp Experience`,
    desc: `
    The Utiva Data Science Bootcamp is a career transformational experience. 
    You will start the journey by learning the technical skills; Python, SQL, Power BI, Predictive and Diagnostic Analytics, Machine Learning etc, then 
    move on to solve complex problems through the capstone project, group coaching sessions and job mentoring programs.
    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Data Science Fundamentals",
      unitTag:
        "Python, Object-Oriented Programming (OOP), Data Cleaning, Exploratory Data Analysis (EDA), Statistical Analysis, Hypothesis Testing, Predictive Models, APIs & Web Scraping, Command Line Scripting, Python Data Visualisation, Code Version Control",
      unitDescription: `
      Data science work relies on programming with languages such as Python and R. In this unit, 
      you'll build core programming skills and leverage data science tools to perform complex data science work. You'll learn how to gather data 
      from the web, complete data wrangling, and use code to perform analysis, build visualisations, and present insights. 
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Master Programming and Python for Data Science",
          featureDescription: `Through this program, you'll learn fundamental programming concepts that will also help you learn other languages 
          in the future, and you'll use Python to perform data cleaning, analysis, visualization, and more.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Learn Essential Statistical Analysis Concepts",
          featureDescription: `You'll practice how Data Scientists perform hypothesis testing to uncover 
          insights, and you'll build predictive models using linear and logistic regression analysis.`,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Perform Advanced-Data Work Using Industry Tools",
          featureDescription: `You'll learn how to work with Python packages and libraries 
          to extend Python's capabilities, and use the command line and git to manage your code.`,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Fundamentals",
      unitTag: "Python, NumPy",
      unitDescription: `
      Get acquainted with essential data science tools and techniques, working in a 
      programming environment to gather, organise, and share 
      projects and data with Git and UNIX. Demonstrate familiarity with introductory programming concepts
      using Python and NumPy to navigate data sources and collections.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Explore Programming Concepts",
          featureDescription: `Demonstrate familiarity with introductory programming concepts 
          using Python and NumPy to navigate data sources and collections. Utilise UNIX commands to navigate file systems and modify files.`,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Learn and Explore Python Libraries",
          featureDescription: `Learn to track changes and iterations using Git version control from your terminal. 
          Define and apply descriptive statistical fundamentals to sample data sets. 
          Practice plotting and visualising data using Python libraries like Matplotlib and Seaborn.
          `,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Exploratory Data Analysis",
      unitTag: "Pandas,SciPy and StatsModels",
      unitDescription: `
      Perform exploratory data analysis. Generate visual and statistical analyses, using Python and its associated 
      libraries and tools to approach problems in fields like finance, marketing, and public policy.
          `,

      unitFeatures: [
        {
          featureIcon: Icon5,
          featureTitle: "",
          featureDescription: `Design an experimental study with a well-thought out problem statement and data framework`,
        },
        {
          featureIcon: Icon6,
          featureTitle: "",
          featureDescription: `Use Pandas to read, clean, parse, and plot data, extracting and rearranging data through indexing, grouping, and Joining.`,
        },
        {
          featureIcon: Icon7,
          featureTitle: "",
          featureDescription: `Review statistical testing concepts (p values, confidence 
            intervals, lambda functions,  correlation/causation) with SciPy and StatsModels.`,
        },
        {
          featureIcon: Icon6,
          featureTitle: "",
          featureDescription: `Explore bootstrapping, Resampling and building inferences about your data.`,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Classical Statistical Modelling",
      unitTag: ``,
      unitDescription: `
      Explore effective study design and model evaluation and optimization, implementing linear and logistic regression, and classification models. 
      Collect and connect external data to add nuance to your models using web scraping and APIs.
          `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "",
          featureDescription: `Use scikit-learn and StatsModels to run linear and logistic regression models and learn to evaluate model fit. 
          Begin to look at classification models by implementing the k-nearest neighbours (kNN) algorithm.
          `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "",
          featureDescription: `Articulate the bias-variance trade-off as you practice evaluating classical statistical models. 
          Use feature selection to deepen your knowledge of study design and model evaluation.
          `,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Machine Learning Models",
      unitTag: `
      Machine Learning,  Exploratory Data Analysis (EDA)
      Supervised Learning, Unsupervised Learning, Feature Engineering, Text Analysis (NLP) & Image Processing, Model Evaluation
      
        `,
      unitDescription: `
      Machine learning is an integral part of data science. It has become commonplace today, powering 
      many of the digital services and technologies used by businesses and consumers. In this unit, you'll dive deep into machine learning 
      fundamentals, and explore various techniques and algorithms used as part of this subset of data science. 
            `,

      unitFeatures: [
        {
          featureIcon: Icon5,
          featureTitle:
            "Explore the differences between supervised and unsupervised learning",
          featureDescription: `Define clustering and its advantages and disadvantages as compared to classification models. 
          Build and evaluate ensemble models using decision trees, random forests, bagging, and boosting. 
          Get acquainted with natural language processing (NLP) through sentiment analysis of scraped website data.
          
            `,
        },
        {
          featureIcon: Icon6,
          featureTitle: "Learn Machine Learning Models",
          featureDescription: `Explore the history and use of Hadoop, as well as the advantages and disadvantages 
          of using parallel or distributed systems to store, access, and analyse big data. 
          Understand how Hive interacts with Hadoop and discover Spark’s advantages through big data case studies.
          Analyse and model time series data using the ARIMA model
          
              `,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "Advanced Topics and Trends",
      unitTag: ``,
      unitDescription: `
      Dive deeper into recommender systems, neural networks, and computer vision models, implementing what you’ve learned to productize models.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Explore Recommendation Systems",
          featureDescription: `Compare and contrast different types of neural networks and demonstrate how they are fit with back propagation. 
          Build and apply basic recommender systems in order to predict on sample user data.
            `,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Professional Development",
          featureDescription: `Work with career coaches to create and polish your professional portfolio. 
          Practice with data science case studies to prepare for job interviews.
          
            `,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 2,
      coachImage: Instructor2,
      coachName: "Damilare Abolaji",
      coachRole: "Senior Business Intelligence Developer, Carbon",
    },
    {
      coachId: 3,
      coachImage: Instructor3,
      coachName: "Chisom Mbama",
      coachRole: "Data Analyst, Brooklyn Data Co.",
    },
    {
      coachId: 4,
      coachImage: Instructor4,
      coachName: "Monday Gabriel",
      coachRole: "Data Analyst Manager, Jeetar Technology Limited",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "Lectures & Lab",
      modelDescription: (
        <>
          <ul className="list-outside ml-3 space-y-2 list-disc">
            <li>Weekend classes</li>
            <li>Intensive training </li>
            <li>Designed to focus on real cases</li>
          </ul>
        </>
      ),
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "Projects and Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Work on more 4+ capstone projects </li>
          <li>Develop multiple Data projects</li>
          <li>Get real-time feedback from coaches</li>
        </ul>
      ),
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "Virtual Apprenticeship",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Real projects designed by companies</li>
          <li>Minimum of 5 Virtual projects</li>
          <li>Submit to supervisors</li>
          <li>2 month virtual apprenticeship</li>
        </ul>
      ),
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "Job and Career Coaching",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>1 month coaching on jobs</li>
          <li>Start applying to roles</li>
          <li>Demo sessions on interviews</li>
        </ul>
      ),
    },
    {
      modelId: 5,
      modelIcon: BusinessImage,
      modelTitle: "A Life Time Access",
      modelDescription: (
        <ul className="list-outside ml-3 space-y-2 list-disc">
          <li>Access to our recorded classes</li>
          <li>Access to the Utiva community </li>
        </ul>
      ),
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "https://www.linkedin.com/in/mayowaadeojo/",
      image: Testimony1,
      firstname: "Mayowa",
      lastname: "Adeojo",
      company: "Business and Data Analyst, Union Bank",
      testimony: `
      Utiva has impacted my career progression in a 
      positive way as the changes in the last couple of months 
      have been rapid. I've had to change roles 
      to a business-oriented role. I've had opportunities to implement 
      my learnings in real-life scenarios, had a role change to a 
      Data Science role, at one of the top financial Institutions in Nigeria.
      `,
    },
    {
      id: 2,
      linkedIn: "https://www.linkedin.com/in/daniel-jude-591b76147/",
      image: Testimony2,
      firstname: "Jude",
      lastname: "Daniel",
      company: "Data Science Fellow",
      testimony: `
      I was looking for something that will give me a clear path 
      to my journey in data science. Thank God I found Utiva 
      at the right moment which happened to fill all the gaps 
      of worries and doubts. My journey so far with Utiva has been amazing. 
      The knowledge I have gained so far has served as the bedrock to 
      my success in the tech space especially in data science. One thing 
      I cherish about Utiva is the Apprenticeship based approach,
       where after the program you will be given a real-life project to work on.
      `,
    },

    {
      id: 3,
      linkedIn:
        "https://www.linkedin.com/in/ayodeji-oyinbo-aca-fcti-mmba-21ba498a/",
      image: Testimony3,
      firstname: "Ayodeji",
      lastname: "Oyinbo",
      company: "Data Science Fellow",
      testimony: `
      I enrolled for the Data science program at Utiva with no 
      prior knowledge. The facilitators were good ensuring we understood what was being taught. 
      The cohort captain was super helpful guiding us all through. The peer to peer 
      review sessions made the learning experience rich and interactive. 
      Overall, I can boldly say enrolling for this program at Utiva is 
      one of the best decisions I made this year.
      `,
    },
  ],

  portofolio: {
    title: "Preparing you for a Career in Data Science",
    description: `
      The end game for us is to make sure that as soon as you leave the fellowship
      you are well equipped to land a great job in data science. Hence, we provide 
      the most intensive jobs support to complement the technical knowledge you have garnered.
      `,

    name: "Samuel Falowo",
    image: PortfolioUserAvatar,
    portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Data Science Certification",
    description: `
    Upon completing Utiva's Data Science Course, you'll receive an industry-recognized, 
    professional Data Science certification to share with your 
    network and showcase all that you've learned. Utiva certificates 
    are formatted for sharing on LinkedIn.
      `,
  },

  videoTestimonial: "https://www.youtube.com/embed/7yscoTvdjEo",
  videoPreviewImage: DataSciencePreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Cloud Bootcamp",
      courseDescription: `This training is designed to help you move into a new tech job 
      within 3 months. That is our goal and hope you are ready for this. You learn the latest skills of the 
      Cloud Developer using the Microsoft Azure program, you will learn how to 
      deploy, build, migrate, and monitor applications on Azure. `,
      courseUrl: "/courses/cloud-bootcamp",
    },
  ],
};
